<template>

    <div class="container">

        <div class="simulator-box">
            <div class="flex-row">
                <div class="col-xs">
                    <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">
                        Educação dos Filhos
                    </h2>
                </div>
                <div class="col-xs flex-no-grow">
                    <a @click="adicionar()" class="btn-floating waves-effect waves-light btn-default">
                        <i class="material-icons">add</i>
                    </a>
                </div>
            </div>


            <div class="card-panel" v-for="(filho, index) in educacao_filhos" :key="index">

                <div class="flex-row bottom-xs mb-5">
                    <div class="col-xs flex-no-grow">
                        <i class="material-icons simulador-icon">accessibility</i>
                    </div>
                    <div class="col-xs-12 col-sm">
                        <label>Nome</label>
                        <input type="text" class='form-control m-0' v-model.trim="filho.nome" @input="salvar(filho, index)">
                    </div>
                    <div class="col-xs-12 col-sm-1">
                        <label>Idade</label>
                        <input type="number" min="0" max="140" class="form-control m-0" v-model="filho.idade" @input="salvar(filho, index)">
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <label>Custo total</label>
                        <input type="text" class="form-control m-0" :value="$options.filters.dinheiro(filho.total_despesas)" readonly tabindex="-1">
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <label>Anos e meses restantes</label>
                        <input type="text" :value="textoPeriodo(filho)" class="form-control m-0" readonly tabindex="-1">
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <div class="input-field actions end-xs">
                            <a class="delete-button text-primary" @click="confirmarExclusao(filho, index)" tabindex="-1">
                                <i class="material-icons">delete</i>
                            </a>
                            <router-link
                                :to="{params: {id: filho.educacao_filho_id}, name: 'cliente_despesa_filho'}"
                                class="btn-floating waves-effect waves-light btn-default"
                                :disabled="!filho.educacao_filho_id">
                                <i class="material-icons">keyboard_arrow_right</i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>


            <div class="card-panel">
                <total-simulador label="TOTAL" :value="custoTotal" />
            </div>

            <footer-simulador :loading.sync="carregando" />

        </div>
    </div>
</template>


<script>

import { put, get, post, remove } from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import debounce from "lodash/debounce";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
import FooterSimulador from '@/components/common/FooterSimulador';

import calculadora from '@/helpers/calculadora.js';
import MaskedInput from "vue-masked-input";

import modal from '@/helpers/wm-modal.js'

export default {

    components: {InputSimulador, SvgPercentage, TotalSimulador, MaskedInput, FooterSimulador},

    name: 'educacao-filhos',


    data() {
        return {
            cliente: null,
            educacao_filhos: [],
            carregando: false,

        }
    },


    computed: {

        custoTotal() {

            let total = 0;

            this.educacao_filhos.forEach( filho  => {
                total += isNaN(filho.total_despesas) ? 0 : filho.total_despesas;
            })

            return total;
        }
    },


    async created() {

        let { id } = this.$route.params;

        let { data: { result: { data: cliente } } } = await get(`cliente/${id}`);

        await cliente.educacao_filhos.map(async filho => {

            let { data: { result: { data: resultado} } } = await get(`educacao-filho/${filho.educacao_filho_id}/total-despesas`);


            this.$set(filho, 'total_despesas', resultado.total_despesas);
            this.$set(filho, 'total_anos_restantes', resultado.formatado.anos);
            this.$set(filho, 'total_meses_restantes', resultado.formatado.meses);

        });

        this.cliente = cliente;

        this.educacao_filhos = cliente.educacao_filhos;

        this.educacao_filhos.length || this.adicionar();
    },


    methods: {

        salvar: debounce(async function (filho, index) {


            if (! filho.nome) return;

            this.carregando = true;

            let resultado;

            try {

                if (filho.educacao_filho_id) {
                    ({data: {result: {data: resultado}}} = await put(`educacao-filho/${filho.educacao_filho_id}`, filho));
                } else {
                    ({data: {result: {data: resultado}}} = await post('educacao-filho', filho));
                }

            } catch (e) {
                throw e;
            } finally {
                setTimeout(() => this.carregando = false, 1500)
            }

            filho.educacao_filho_id = resultado.educacao_filho_id;

        }, 250),

        adicionar() {

            this.educacao_filhos.push({
                total_despesas: 0,
                total_anos_restantes: 0,
                total_meses_restantes: 0,
                nome: '',
                idade: '',
                cliente_id: this.$route.params.id
            })
        },

        async confirmarExclusao(filho, index)
        {
            let resultado = await modal.confirm({
                text: "Confirma a exclusão desse filho?",
                title: 'Confirmação'
            })

            if (! resultado) return;


            this.excluir(filho, index);
        },

        async excluir(filho, index) {

            if (filho.educacao_filho_id) {

                await remove(`educacao-filho/${filho.educacao_filho_id}`)
            }

            this.educacao_filhos.splice(index, 1);
        },

        textoPeriodo(filho) {

            if (!filho.total_anos_restantes && !filho.total_meses_restantes) {
                return '';
            }


            let texto = [];

            if (filho.total_anos_restantes) {

                texto.push(`${filho.total_anos_restantes} ${filho.total_anos_restantes > 1 ? 'anos' : 'ano'}`);
            }

            if (filho.total_meses_restantes) {
                texto.push(`${filho.total_meses_restantes} ${filho.total_meses_restantes > 1 ? 'meses' : 'mês'}`);
            }


            console.log(texto)


            return texto.join(' e ');
        }
    }
}
</script>


<style lang="scss" scoped>


.delete-button{
    display: block;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    cursor: pointer;
}

.actions{
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/clientes/EducacaoFilhos.vue